import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-502360a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pannel bg-white"
}
const _hoisted_2 = { class: "flex p-3 justify-content-between header align-items-center" }
const _hoisted_3 = { class: "flex gap-3 align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "ci-action-check text-primary-blue"
}
const _hoisted_5 = {
  key: 1,
  class: "ci-action-close text-red"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "app-label-small font-bold text-default-gray" }, "Changement email", -1))
const _hoisted_7 = {
  key: 0,
  class: "app-label-micro text-primary-blue"
}
const _hoisted_8 = {
  key: 1,
  class: "app-label-micro text-primary-blue"
}
const _hoisted_9 = {
  key: 2,
  class: "app-label-micro text-red"
}
const _hoisted_10 = {
  key: 0,
  class: "flex flex-column align-items-start gap-3 p-6"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-column gap-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-d1 font-bold" }, "Votre email a été modifié avec succès."),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "app-label text-default-gray" }, "Vous pouvez dès à présent vous connecter en utilisant votre nouvel email.")
  ])
], -1))
const _hoisted_12 = {
  key: 1,
  class: "flex flex-column align-items-start gap-3 p-6"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-column gap-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-d1 font-bold" }, "Une erreur est survenue."),
  /*#__PURE__*/_createElementVNode("p", { class: "app-label text-default-gray" }, "La modification de votre email n'a pas pu être effectué.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.result?.status == 200)
                ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                : (_openBlock(), _createElementBlock("i", _hoisted_5)),
              _hoisted_6
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "En cours"))
              : (_ctx.result?.status == 200)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Validé"))
                : (_openBlock(), _createElementBlock("p", _hoisted_9, "Erreur"))
          ]),
          (!_ctx.loading && _ctx.result?.status == 200)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_app_button, {
                      buttonType: "main",
                      buttonSize: "m",
                      buttonText: "Se connecter"
                    })
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_app_button, {
                      buttonType: "main",
                      buttonSize: "m",
                      buttonText: "Suivant"
                    })
                  ]),
                  _: 1
                })
              ]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 1,
          mode: "indeterminate",
          class: "h-5rem"
        }))
      : _createCommentVNode("", true)
  ], 64))
}